<template>
    <div id="contatos">
        <div class="header">
            <div style="display: flex; flex-direction: column; align-items: start; width: 70%;">
                <v-btn @click="$emit('close-item')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">Contatos</p>
            </div>


        </div>

        <div>
            <v-list v-if="loaded && contatos.length >= 1 && !semCoach">
                <v-list-item height="60px" @click="openContent(contato)" v-for="contato in contatos" :key="contato"
                    :value="contato">
                    <template v-slot:prepend>
                        <div class="icon-wrapper">
                            <img style="width: 20px;"
                                src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/54dfa5a2-f06f-4a68-a025-2cb5b9e45642.svg"
                                alt="">
                        </div>

                        <div>
                            <v-list-item-title style="margin-left: 20px;" v-text="contato['NOME_COACH']"></v-list-item-title>
                        </div>
                    </template>

                    <template v-slot:append>
                        <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/1b595908-3f7a-451d-aa09-30178d5456fd.svg"
                            alt="">
                    </template>
                </v-list-item>

            </v-list>
            <v-progress-circular
                v-else-if="!loaded && contatos.length === 0"
                indeterminate
                color="#BC4AFF"
                :size="70"
                :width="7"
                style="margin-top: 10%;"
            ></v-progress-circular>
            <div v-else-if="loaded && semCoach">
                <img style="width: 70%; margin-top: 10%;" src="//overmediacast-videos-sp.s3-sa-east-1.amazonaws.com/65ef2558e34902000230c37c/fdb158ee-9282-4394-83ab-cb62bb2abeb2.svg" alt="">
                <p style="margin-top: 10%;">Em breve, o contato do coach estará disponível</p>
            </div>
        </div>
    </div>

    <ContatoModal @close-modal="showModal = false" v-if="showModal" :contato="contatoToOpen" />
</template>

<script setup>
import { defineEmits, ref, onMounted } from 'vue';
import ContatoModal from './ContatoModal.vue';
import requestApi from '@/utils/requestApi'
import { useGlobalStateStore } from '../../../../store';

const globalStateStore = useGlobalStateStore();

defineEmits(["close-item"])

const contatoToOpen = ref(null)
const showModal = ref(false)

const contatos = ref([])
const loaded = ref(false)
const semCoach = ref(false)

onMounted(async () => { 
    await checkContatos()
})

function checkContatos(){
    requestApi(
        {
            url: `v2/vivo_integration/video/${process.env.VUE_APP_VIDEO_ID}/user/${window.ovmConfig.env['CPF']}/get_data_coach`,
            method: 'get',
            headers: {
                BCS: globalStateStore.uuid,
                'Content-Type': 'application/json',
            }
        }
    ).then(response => {
        contatos.value.push(response.data)
        if (contatos.value[0].NOME_COACH === null) {
            semCoach.value = true
        }
        loaded.value = true
    }).catch(() => {
        loaded.value = true
    })
}

const openContent = (contact) => {
    contatoToOpen.value = contact
    showModal.value = true;
}
</script>

<style scoped>
#contatos {
    width: 100%;
    height: 90%;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 1;
    overflow-y: auto;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
    display: flex;
}

.submenu-title {
    color: white;
    margin-top: 15%;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
}

.icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F6E7FF;
    border-radius: 50%;
    margin-right: 20px;
}
</style>